import React, {useContext} from 'react';
import {Context} from '../components/utils/store'
import './filters.css'
import Options from "../components/utils/ui_controls";

const Filters = () => {
    const [state, dispatch] = useContext(Context);
    const date_agg_options = [
            {value:"hour",    label:"hourly"},
            {value:"day",     label:"daily"},
            {value:"week",    label:"weekly"},
            {value:"month",   label:"monthly"},
            {value:"year",    label:"yearly"}
        ]
    const validate = (name, value) => {
        if( ['date_from','date_to'].indexOf(name) >= 0 ){
            var d = new Date(value)
            return value.match(/^\d{4}-\d{2}-\d{2}$/) && (d instanceof Date)
        }
        return true
    }
    const handleChange = (e) => {
        const value = e.target.value
        const name = e.target.name
        if(!validate(name, value)) return;
        const filters = {}
        filters[name] = value
        dispatch({type:'ADD_FILTERS', payload:filters})
    }


    return <div className={"filters"}>

        <span className={"filter"}>
            <label>date range:</label>
            <input name={"date_from"} onBlur={handleChange} defaultValue={state.filters.date_from}/>&nbsp;:&nbsp;
            <input name={"date_to"} onBlur={handleChange} defaultValue={state.filters.date_to}/>
        </span>
        <span className={"filter"}>
        <label>date bin:</label>
            <select name={"date_aggregation"} value={state.filters.date_aggregation} onChange={handleChange}>
                <Options options={date_agg_options} />
            </select>
        </span>
        {/*<span className={"filter"}>*/}
        {/*    <label>search for:</label>*/}
        {/*    <input name={"search_txt"} onBlur={handleChange} defaultValue={""}/>*/}
        {/*</span>*/}
    </div>
}

export default Filters